import type { ToolTrackingConfig } from '@analytics/models';
import { createToolStepConfig, parseToolConfig } from '@analytics/utils';

import { selectTariffBreakdownAnalyticsPayload } from './tariff-breakdown.selectors';

const tariffBreakdownSteps = [
  {
    step: 0,
    stepName: 'tarief berekening',
    id: 'calculation',
  },
] as const;

export type TariffBreakdownToolTrackingSteps =
  (typeof tariffBreakdownSteps)[number]['id'];

const tariffBreakdownToolTrackingConfig: ToolTrackingConfig<TariffBreakdownToolTrackingSteps> =
  {
    toolName: 'tarief berekening',
    steps: tariffBreakdownSteps,
    toolComplete: createToolStepConfig(
      selectTariffBreakdownAnalyticsPayload,
      (action) => ({
        step: 1,
        payload: {
          postcode: action.postalCode,
        },
      })
    ),
  };

export const parsedTariffBreakdownToolTrackingConfig = parseToolConfig(
  tariffBreakdownToolTrackingConfig
);
